import { useState } from 'react';

import DropZone from 'components/dropzone';
import ProgressBar from 'components/progressBar';

function ImportDropZone() {
  const [files, setFiles] = useState([] as File[]);

  const onDrop = (acceptedFiles: File[]) => {
    if (!acceptedFiles || !acceptedFiles.length) return;
    // Do something with the files
    setFiles(acceptedFiles);
  };

  const onDelete = (index: number) => {
    const newFiles = [...files.slice(0, index), ...files.slice(index + 1)];
    setFiles(newFiles);
  };

  return (!files || !files.length) ? (
    <DropZone onDrop={onDrop} />
  ) : (
    <>
      {files.map((file, index) => (
        <ProgressBar
          key={index}
          file={file}
          onDelete={() => onDelete(index)}
        />
      ))}
    </>
  );
}

export default ImportDropZone;
